// PrescriptionPage.js
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer.js";
import Prescription from "../components/Prescription/Presciption.js";
import { useLocation } from "react-router-dom";

function PrescriptionPage() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div className="page-container">
      <div className="content-wrap">
        <Prescription />
      </div>
    </div>
  );
}

export default PrescriptionPage;
